import React from 'react';
import Alert from '@mui/material/Alert';
import { usePartnerScope } from '../contexts/PartnerScopeContext';

/**
 * Shown on pages whose edit controls are disabled for internal users viewing
 * a partner (SOPHIA-35120). The APIs reject those writes server-side; this
 * banner explains why the controls are gone.
 */
export function ImpersonationReadOnlyBanner(): React.ReactElement | null {
  const { isInternal } = usePartnerScope();

  if (!isInternal) return null;

  return (
    <Alert severity="info" sx={{ mb: 2 }} data-testid="impersonation-readonly-banner">
      Viewing as partner — read-only. Only the partner&apos;s own users can make changes on this
      page.
    </Alert>
  );
}
